import { render } from "./OutputInfo.vue?vue&type=template&id=5aff2539&scoped=true"
import script from "./OutputInfo.vue?vue&type=script&lang=js"
export * from "./OutputInfo.vue?vue&type=script&lang=js"

import "./OutputInfo.vue?vue&type=style&index=0&id=5aff2539&lang=scss&scoped=true"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aff2539"]])

export default __exports__